import { useCallback } from 'react';
import { captureEvent } from '../../lib/analytics';
import { ModalType, CrisisPractitionerData } from './types-constants';

export function useCrisisPractitionerModal(
  openModal: (type: ModalType, data?: Record<string, unknown>) => void
) {
  const triggerPractitionerPrompt = useCallback(
    (data?: CrisisPractitionerData) => {
      openModal(ModalType.CRISIS_PRACTITIONER, data);

      captureEvent('Safety_PractitionerPromptOpened', {
        severity: data?.severity || 'medium',
        has_moderation_event: !!data?.moderationEventId,
      });
    },
    [openModal]
  );

  return {
    triggerPractitionerPrompt,
  };
}
